import React from 'react';
import { TldOfferCarousel } from '../carousel/TldOfferCarousel';
import { TldOfferWidgetModule } from '../tldOfferWidget.module';
import { storefrontLayout } from './storefront.layout';
export const StorefrontCarousel = _ref => {
  let domain = _ref.domain;
  return /*#__PURE__*/React.createElement(TldOfferWidgetModule.Provider, {
    Layouts: {
      customConfiguration: storefrontLayout
    }
  }, /*#__PURE__*/React.createElement(TldOfferCarousel, {
    key: domain,
    domain: domain
  }));
};
//# sourceMappingURL=StorefrontCarousel.js.map